import React from "react";
import { Container, Col, Row } from "reactstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { JsonToTable } from "react-json-to-table";
import Dropdown from "react-bootstrap/Dropdown";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import { useCustomStylesDropDown } from "../../assets/css/customStyle";
import { usePFFundUploader } from "../../hooks/usePFFundUploader";
import Config from "../../config";
function PFFundUploader() {
  const { customStyles } = useCustomStylesDropDown();

  const {
    // State
    fileName,
    fileData,
    fileDataCount,
    displayLimit,
    fileValidationErrors,
    fund,
    loading,
    companyOptions,
    companyName,
    loadingCompany,
    fundBankAccount,
    counterFundLoading,
    allCounterFundsAccounts,
    ErrorModal,
    errorInData,
    myRef1,
    isInitialContribution,
    isMonthlyContribution,

    // Setters
    setFund,
    setCompanyName,
    setFundAccount,
    setErrorModal,

    // Functions
    upload,
    handleUploadClick,
    handleLoadMore,
    renderFundsDropdown,
    selectedFundName,
  } = usePFFundUploader();

  return (
    <div className="content">
      {/* Server Upload Error Modal */}
      <Modal
        show={ErrorModal}
        dialogClassName="modal90w"
        size="xl"
        centered
        onHide={() => setErrorModal(false)}
      >
        <div className="modal-header">
          <button className="close" onClick={() => setErrorModal(false)}>
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title">Server Upload Errors - Kindly Resolve First</h6>
        </div>

        <div className="modal-body">
          {errorInData.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="text-primary">
                  <tr>
                    <th>Row No.</th>
                    <th>Folio No.</th>
                    <th>Error Description</th>
                  </tr>
                </thead>
                <tbody>
                  {errorInData.map((err: any, i) => (
                    <tr key={i}>
                      <td>{err.row}</td>
                      <td>{err.folio_no}</td>
                      <td className="text-danger">
                        <i className="tim-icons icon-alert-circle-exc mr-2" />
                        {err.error}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>No specific errors</p>
          )}
        </div>
      </Modal>

      <Row>
        <Col md="12">
          <Container fluid>
            <ToastContainer limit={1} />

            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  {isInitialContribution
                    ? "Provident Fund Initial Contribution Uploader"
                    : "Provident Fund Monthly Deposit Uploader"}
                  <Dropdown className="float-right">
                    <Dropdown.Toggle
                      href={`${Config.baseUrl}${
                        isInitialContribution
                          ? "PF-INITIAL-CONTRIBUTION-SAMPLE.xlsx"
                          : "PF-SAMPLE.xlsx"
                      }`}
                      variant="dark"
                    >
                      Download Sample
                    </Dropdown.Toggle>
                  </Dropdown>
                </h4>
              </div>

              <div className="card-body">
                <div className="row">
                  <div className="form-group col-md-2">
                    <label>Company Name</label>
                    <Select
                      isLoading={loadingCompany}
                      value={companyName}
                      onChange={setCompanyName}
                      isClearable
                      isSearchable
                      options={companyOptions}
                      styles={customStyles}
                    />
                  </div>

                  <div className="form-group col-md-2">
                    <label>Fund</label>
                    <Select
                      isDisabled={!companyName?.value}
                      value={selectedFundName}
                      onChange={(e) => setFund(e?.value)}
                      isClearable
                      isSearchable
                      options={renderFundsDropdown()}
                      styles={customStyles}
                    />
                  </div>

                  <div className="form-group col-md-2">
                    <label>Fund Account*</label>
                    {counterFundLoading ? (
                      <div className="form-control w-100">
                        <i className="fa fa-spinner fa-spin fa-1x"></i>
                      </div>
                    ) : (
                      <Select
                        label={"Select"}
                        onChange={(e) => {
                          setFundAccount(e.value);
                        }}
                        value={
                          allCounterFundsAccounts.filter((option) => {
                            return (
                              option.value?.account_no ===
                              fundBankAccount?.account_no
                            );
                          })?.label
                        }
                        isClearable={true}
                        isSearchable={true}
                        options={allCounterFundsAccounts}
                        styles={customStyles}
                      />
                    )}
                  </div>

                  <div className="form-group col-md-2">
                    <label>Choose File</label>

                    <div onClick={() => myRef1?.current?.click()}>
                      <div>
                        <div className="form-control">
                          {fileName || "Upload File"}
                        </div>

                        <input
                          type="file"
                          ref={myRef1}
                          style={{ display: "none" }}
                          onChange={(e) => {
                            if (fund) upload(e);
                            else {
                              const toast = require("react-toastify").toast;
                              toast.error("Select fund first");
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* File Validation Errors Display */}
                {fileValidationErrors.length > 0 && (
                  <div className="mt-3" role="alert">
                    <h5 className="alert-heading">
                      <i className="tim-icons icon-alert-circle-exc mr-2" />
                      File Validation Errors ({fileValidationErrors.length})
                    </h5>
                    <hr />
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "400px", overflowY: "auto" }}
                    >
                      <table className="table table-sm table-hover">
                        <thead className="sticky-top bg-danger text-white">
                          <tr>
                            <th>Row #</th>
                            <th>Field</th>
                            <th>Value</th>
                            <th>Error Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {fileValidationErrors.map((err, idx) => (
                            <tr key={idx}>
                              <td>
                                <strong>{err.row}</strong>
                              </td>
                              <td>
                                <code>{err.field}</code>
                              </td>
                              <td>
                                <span className="text-muted">
                                  {err.value || <em>(empty)</em>}
                                </span>
                              </td>
                              <td>{err.error}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-2">
                      <small className="text-muted">
                        <i className="tim-icons icon-bulb-63 mr-1" />
                        Please fix these errors in your file and upload again.
                      </small>
                    </div>
                  </div>
                )}

                {/* Data Preview with Pagination */}
                {fileData.length > 0 && (
                  <div className="mt-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">
                        <i className="tim-icons icon-notes mr-2" />
                        File Preview
                      </h5>
                      <span className="badge badge-primary badge-pill">
                        Showing {Math.min(displayLimit, fileData.length)} of{" "}
                        {fileData.length} records
                      </span>
                    </div>

                    <div
                      className="table-responsive"
                      style={{ maxHeight: "600px", overflowY: "auto" }}
                    >
                      <JsonToTable json={fileData.slice(0, displayLimit)} />
                    </div>

                    {displayLimit < fileData.length && (
                      <div className="text-center mt-3">
                        <button
                          className="btn btn-outline-primary"
                          onClick={handleLoadMore}
                        >
                          <i className="tim-icons icon-refresh-01 mr-2" />
                          Load More ({fileData.length - displayLimit} remaining)
                        </button>
                      </div>
                    )}
                  </div>
                )}

                <div className="mt-3 d-flex justify-content-between align-items-center">
                  <p className="mb-0">
                    Total Rows:{" "}
                    <span className="badge badge-info">{fileDataCount}</span>
                    {fileValidationErrors.length > 0 && (
                      <span className="ml-3 text-danger">
                        <i className="tim-icons icon-alert-circle-exc mr-1" />
                        Errors: {fileValidationErrors.length}
                      </span>
                    )}
                  </p>

                  <button
                    className="btn btn-primary"
                    onClick={handleUploadClick}
                    disabled={
                      loading ||
                      !fileData.length ||
                      fileValidationErrors.length > 0
                    }
                  >
                    {loading ? (
                      <>
                        <i className="fa fa-spinner fa-spin mr-2" />
                        Uploading...
                      </>
                    ) : (
                      <>
                        <i className="tim-icons icon-cloud-upload-94 mr-2" />
                        Upload to Server
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Container>
        </Col>
      </Row>
    </div>
  );
}

export default PFFundUploader;
